import React, { useContext, useEffect } from "react";
import "./WorkOverview.scss";
import MyContext from "../../../Common/Context/MyContext";
import { useNavigate } from "react-router-dom";

const WorkOverview = () => {
  const { token, adata, fetchAtten, usertoken, fetchusertoken } =
    useContext(MyContext);

 

  const Navigate = useNavigate();

  useEffect(() => {
    !token ? Navigate("/login") : fetchAtten();
    fetchusertoken();
   
  }, []);

  return (
    <div className="work-overview">
      {adata && adata.length > 0 ? (
        adata
          .filter((item) =>  item.name === usertoken?.name)
          .map((item, index) => {
            const formattedDate = new Date(item.date).toLocaleDateString(
              "en-GB"
            );
            return (
              <div className="data-item" key={index}>
                <p>
                  <strong>Date:</strong> {formattedDate}
                </p>
                <p>
                  <strong>Description:</strong> {item.work}
                </p>
              </div>
            );
          })
      ) : (
        <p className="no-data">No data available</p>
      )}
    </div>
  );
};

export default WorkOverview;
